import React from "react";
import AuthHeader from "../../components/Layouts/AuthHeader";
import LoginForm from "../../components/Auth/LoginForm";

const Login = () => {
  return (
    <>
      <AuthHeader />
      <LoginForm />
    </>
  );
};

export default Login;
